<template>
  <!-- Analysis -->
  <div class="row f-row justify-content-center h-100">
    <div class="f-row h-100">
      <div
        class="left-sidebar-front-div"
        v-if="userSelections.visibleLeft"
        @click="changeVisible"
      ></div>
      <!-- Sidebar lateral -->
      <LeftSidebar
        :selectedAnalysis="['userSelections']['selectedAnalysis']"
        :selectedAnalysisParent="['userSelections']['selectedAnalysisParent']"
        :visibleLeft="userSelections.visibleLeft"
        :listAnalysis="view"
        :currencySpecs="currencySpecs"
        :currencyInformation="currencyDefs"
        :activeElements="activeElements"
        :showLoading="showLoading"
        :spot="spot"
        :updatedDate="updatedDate"
        @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
        @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
        @onUserChangeAnalysis="onUserChangeAnalysis"
        @onUserCurrencySelection="onUserCurrencySelection"
      />
      <div class="h-100 d-flex flex-column largeBox row f-row">
        <div class="row f-row justify-content-center h-100">
          <!-- Currencies -->
          <div v-if="selectedShowView === 'worldCurrencies'" class="col col-12">
            <CurrencyWorld
              :againstCurrency="againstCurrency"
              :colorTheme="colorTheme"
              :controls="'large'"
              :currencyDefs="currencyDefs"
              :currencyNumber="currencyNumber"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </CurrencyWorld>
          </div>
          <!-- Commodities -->
          <div
            v-else-if="selectedShowView === 'worldCommodities'"
            class="col col-12"
          >
            <CommoditiesMulti
              :colorTheme="colorTheme"
              :controls="'large'"
              :processData="processData"
              :selectedCommodity="-1"
              :commoditySpecs="commoditySpecs"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </CommoditiesMulti>
          </div>
          <!-- Dot plot -->
          <div v-else-if="selectedShowView === 'dotPlot'" class="col col-12">
            <DotPlot :processData="processData" :colorTheme="colorTheme">
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                  :qtyColumns="screenWidth < 1400 && screenWidth > 1100 ? 4 : 5"
                />
              </template>
            </DotPlot>
          </div>
          <!-- Macro -->
          <div v-else-if="selectedShowView === 'macro'" class="col col-12">
            <Fundamentals
              :colorTheme="colorTheme"
              :countrySpecs="countrySpecs"
              :currencyStr="currencyDefs.currency_name"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Fundamentals>
          </div>

          <!-- Commitment of traders -->
          <div
            v-else-if="selectedShowView === 'commitmentTraders'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <CommitmentTraders
              :colorTheme="colorTheme"
              :commoditySpecs="commoditySpecs"
              :currencySpecs="currencySpecs"
              :currencyDefs="currencyDefs"
              :indexSpecs="indexSpecs"
              :isCurrency="true"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </CommitmentTraders>
          </div>

          <!-- Correlations -->
          <div
            v-else-if="selectedShowView === 'correlations'"
            class="col col-12"
          >
            <Correlations
              :colorTheme="colorTheme"
              :contract="1"
              :currencyNumber="currencyNumber"
              :currencyString="currencyDefs"
              :isCurrency="true"
              :processData="processData"
              ><template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Correlations>
          </div>

          <!-- Comparison -->
          <div
            v-else-if="selectedShowView === 'comparison'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Comparison
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :currencyString="currencyDefs"
              :dataReady="dataReady"
              :isCurrency="true"
              :processData="processData"
              :showLoadingParent="showLoading"
              :render="render"
              :initCompareType="compareType"
              :initCompareAsset="compareAsset"
              @onComparisonSelection="onComparisonSelection"
              @resizeCharts="resizeCharts"
              ><template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Comparison>
          </div>
          <!-- Forecasts -->
          <div
            v-else-if="selectedShowView === 'forecast'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Forecast
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :currencyNumber="currencyNumber"
              :currencyString="currencyDefs"
              :dataReady="dataReady"
              :expandLeft="true"
              :hideRight="true"
              :processData="processData"
              :showDumbell="false"
              :showLoading="showLoading"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Forecast>
          </div>
          <!-- Forecast Analysis -->
          <div
            v-else-if="selectedShowView === 'forecastAnalysis'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <ForecastAnalysis
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :commodityDefs="currencyDefs"
              :dataReady="dataReady"
              :isCurrency="true"
              :processData="processData"
              :selectedCurrency="selectedCurrency"
              :currencyString="currencyDefs"
              :showLoading="showLoading"
              ><template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </ForecastAnalysis>
          </div>
          <!-- Seasonality -->
          <div
            v-else-if="selectedShowView === 'seasonality'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Seasonality
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :renderSeasonality="dataReady"
              :selectedCurrency="selectedCurrency"
              :showLoading="showLoading"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Seasonality>
          </div>

          <!-- Percentiles -->
          <div
            v-else-if="selectedShowView === 'percentiles'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Percentiles
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :renderPercentile="dataReady"
              :showLoading="showLoading"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Percentiles>
          </div>

          <!-- Trend -->
          <div
            v-else-if="selectedShowView === 'trend'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Trends
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :showLoading="showLoading"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Historical trends'"
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </Trends>
          </div>

          <!-- Relative Value -->
          <div
            v-else-if="selectedShowView === 'relativeValue'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <RelativeValue
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :currencyNumber="currencyNumber"
              :currencyString="currencyDefs"
              :dataReady="dataReady"
              :expandRight="false"
              :hideLeft="false"
              :isCurrency="true"
              :processData="processData"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :analysisName="activeElements.analysis + ' analysis'"
                  :colorTheme="colorTheme"
                  :qtyColumns="12"
                  :showLoadingSpot="showLoadingSpot"
                  :spot="showLoadingSpot === true ? null : spot"
                  :spotAnimate="spotAnimate"
                  :updateDate="updatedAt"
                />
              </template>
            </RelativeValue>
          </div>

          <!-- Technical Analysis -->
          <div
            v-else-if="selectedShowView === 'techAnalysis'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <TechnicalAnalysis
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :selectedCurrency="currencyDefs.currency_name"
              :showLoading="showLoading"
              :spot="spot"
              ><template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Technical analysis'"
                  :updateDate="updatedAt"
                />
              </template>
            </TechnicalAnalysis>
          </div>
          <!-- Patterns -->
          <div
            v-else-if="selectedShowView === 'patterns'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <PatternRecognition
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :showLoading="showLoading"
              ><template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="
                    'History (hover over chart to visualize patterns)'
                  "
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </PatternRecognition>
          </div>

          <!-- Forward and Volatility -->
          <div v-else-if="selectedShowView === 'pricing'" class="col col-12">
            <Pricing
              :colorTheme="colorTheme"
              :currencyNumber="currencyNumber"
              :processData="processData"
              :showHistory="true"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpot === true ? null : spot"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Forwards and options'"
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </Pricing>
          </div>

          <!-- Summary -->
          <div
            v-else-if="summarySelected === true"
            style="height: 100%; width:100%; padding: 0;"
          >
            Summary
          </div>
          <!-- If nothing selected -->
          <div v-else style="height: 95%;width:100%">
            <div
              class="text-center"
              style="width:100%; background: var(--background-alpha);
              color: var(--textactive); font-size: 1.2rem;"
            >
              Select analysis on the right panel
            </div>
            <div
              :style="{
                backgroundImage:
                  'url(' + require('@/assets/images/fondoNY6.jpg') + ')',
              }"
              style="height: 100%; width:100%; background-size: cover;"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { apiService } from "@/_services";
import {
  colorSelection,
  numberFormat,
  formatPercent,
  dateFormat,
} from "@/_core/_helpers/_parametric_tools";
import { format, selectAll } from "d3";
import {
  formatDate_YMD,
  formatDate_DDMMMYHMS,
  timeParseNoNull2,
} from "@/_core/_helpers/_helpers";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getDefaultMarketsPreferences } from "@/_core/data/Markets";
import { getMenu } from "@/_core/data/api_calls/menu/getMenu";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { ProcessData } from "@/_core/data/ProcessData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import CommitmentTraders from "@/components/markets/CommitmentOfTraders";
import CommoditiesMulti from "@/components/markets/CommoditiesMulti";
import Comparison from "@/components/markets/Comparison";
import Correlations from "@/components/markets/Correlations";
import CurrencyWorld from "@/components/markets/CurrencyWorld";
import DetailsDisplay from "./MarketDetails/DetailsDisplay.vue";
import DotPlot from "./DotPlot.vue";
import Forecast from "@/components/markets/Forecast.vue";
import ForecastAnalysis from "@/components/markets/ForecastAnalysis.vue";
import Fundamentals from "@/components/markets/Fundamentals";
import LeftSidebar from "./Sidebar/LeftSidebar.vue";
import Messages from "@/components/modals/Messages.vue";
import {
  marketsRouteSync,
  slugifyProductItem,
} from "@/components/markets/marketsRouteSync";
import PatternRecognition from "@/components/markets/PatternRecognition.vue";
import Percentiles from "@/components/markets/Percentiles";
import Pricing from "@/components/markets/Pricing.vue";
import RelativeValue from "@/components/markets/RelativeValue.vue";
import Seasonality from "@/components/markets/Seasonality";
import TechnicalAnalysis from "@/components/markets/TechnicalAnalysis.vue";
import Trends from "@/components/markets/Trends.vue";

export default {
  name: "Currency",
  mixins: [marketsRouteSync],
  components: {
    CommitmentTraders,
    CommoditiesMulti,
    Comparison,
    Correlations,
    CurrencyWorld,
    DetailsDisplay,
    DotPlot,
    Forecast,
    ForecastAnalysis,
    Fundamentals,
    LeftSidebar,
    Messages,
    PatternRecognition,
    Percentiles,
    Pricing,
    RelativeValue,
    Seasonality,
    TechnicalAnalysis,
    Trends,
  },
  props: {
    user: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
  },
  data() {
    return {
      activeElements: {
        currency: "",
        analysis: "",
      },
      againstCurrency: true,
      chartDataRaw: [],
      colorSelection: colorSelection,
      commoditySpecs: [],
      connection: null,
      countrySpecs: [],
      currencyDefs: { currency_name: "na" },
      currencyNumber: 0,
      currencySpecs: [],
      // Comparison view selection (asset type + asset), synced to the URL.
      compareType: null,
      compareAsset: null,
      dataReady: 0,
      dateFormat: dateFormat,
      faildGetHistoricalData: true,
      formatDate_YMD: formatDate_YMD,
      formatPercent: formatPercent,
      indexSpecs: [],
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      marketsAsset: "currency",
      marketsGlobalKeys: ["worldCurrencies", "worldCommodities", "dotPlot"],
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      numberFormat: numberFormat,
      previousSpot: null,
      processData: null,
      quanspireMenuData: {},
      render: false,
      selectedCurrency: 11,
      selectedView: 0,
      screenWidth: 0,
      showLoading: false,
      showLoadingSpot: false,
      spot: null,
      spotAnimate: 0,
      spotData: null,
      summarySelected: false,
      updatedAt: null,
      updatedDate: null,
      userSelections: {
        selectedAnalysis: "",
        selectedAnalysisParent: "",
        visibleLeft: false,
      },
      onUsers: {
        elementChange: "",
      },
      view: {
        techAnalysis: { value: 0, name: "Technical analysis", show: true },
      },
      view_quanspire: {},
      view_user: {},
    };
  },
  created() {
    // get all local data
    this.markets_preferences = getDefaultMarketsPreferences(this)["choices"];
    this.processData = new ProcessData();
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.error(`Error countries ${error}`);
    }
    try {
      this.selectedCurrency = this.markets_preferences.selected_currency;
    } catch (error) {
      console.error(`Error currencies preferences ${error}`);
    }
    if (this.$route.params.productType === this.marketsAsset) {
      const routeItemSlug = this.marketsRouteItemFromRoute(this.$route);
      const routeItemIndex = routeItemSlug
        ? this.marketsFindItem(routeItemSlug)
        : -1;
      if (routeItemIndex > -1) {
        this.selectedCurrency = routeItemIndex;
        this.markets_preferences.selected_currency = routeItemIndex;
      }
    }
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.indexSpecs = this.$store.state.indexes.all.items;
    } catch (error) {
      console.error(`Error indexes ${error}`);
    }
    this.showLoadingSpot = true;
    this.showLoading = true;
    Object.assign(this, {
      currencyDefs: this.currencySpecs[this.selectedCurrency],
    });
    this.currencyNumber = this.currencyDefs.pk_i_idcurrency;
    let asset = "currency";
    getMenu(this, asset).then(() => this.onMarketsMenuLoaded());
    this.getSpotDataFn();

    Object.assign(this.activeElements, {
      currency: this.currencyName,
      analysis: this.view[this.selectedShowView].name,
    });
    document.title = "Markets | Fx";
  },
  mounted() {
    this.updateScreenWidth();
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
  },
  watch: {
    loadingSpotHistorical(val) {
      if (val === false) {
        if (this["spot"] == null) {
          let nLen = this["chartDataRaw"].length - 1;
          this["spot"] = this["chartDataRaw"][nLen].close;
        } else {
          Object.assign(this, {
            chartDataRaw: this.processData.includeSpotNew(
              this["chartDataRaw"],
              this["spotData"],
            ),
          });
          this["dataReady"] += 1;
        }
      }
    },
    chartDataRaw: {
      handler(data) {
        this.verifySpotData();
        this.verifyLastTwoDates(this, data);
      },
      deep: true,
    },
    selectedShowView(newVal) {
      Object.assign(this.activeElements, {
        analysis: this.view[newVal].name,
      });
    },
  },
  computed: {
    loadingSpotHistorical() {
      return this["showLoadingSpot"] || this["showLoading"];
    },
    selectedViewBoolean: {
      get() {
        return this.selectedView === 1;
      },
      set() {
        return false;
      },
    },
    viewResult: function() {
      let ave = 0;
      const keys = Object.keys(this.view);
      for (const item of keys) {
        ave += this.view[item].value;
      }
      return Math.round((10 * ave) / keys.length) / 10;
    },
    selectedShowView: function() {
      let sel = "techAnalysis";
      let analysisName = "";
      let keys = Object.keys(this.view);
      for (const item of keys) {
        if (this.view[item].show === true) {
          sel = item;
          analysisName = this.view[item];
        }
      }
      if (analysisName) {
        Object.assign(this.activeElements, {
          analysis: analysisName.name,
        });
      }
      return sel;
    },
    currencyName() {
      return this.currencyDefs.currency_name;
    },
    analysisName() {
      return this.view[this.selectedShowView].name;
    },
  },
  methods: {
    onUserSummarySelected() {
      this.summarySelected = !this.summarySelected;
      var keys = Object.keys(this.view);
      for (const key of keys) {
        this.view[key].show = false;
      }
    },
    onUserChangeAnalysis({ item }) {
      item.show = !item.show;
      this.summarySelected = false;
      var keys = Object.keys(this.view);
      for (const key of keys) {
        Object.assign(this.view[key], {
          show: item.name === this.view[key].name,
        });
      }
      Object.assign(this.activeElements, {
        analysis: this.view[this.selectedShowView].name,
      });
      this.syncMarketsRoute();
    },
    onUserCurrencySelection({ item }) {
      this.spot = null;
      const indexCurr = this.currencySpecs.findIndex(
        (d) => d.currency_name === item.currency_name,
      );
      Object.assign(this, {
        selectedCurrency: indexCurr,
      });
      this.chartDataRaw = [];
      this.showLoadingSpot = true;
      this.showLoading = true;
      Object.assign(this, {
        currencyDefs: this.currencySpecs[this.selectedCurrency],
      });
      this.currencyNumber = this.currencyDefs.pk_i_idcurrency;
      this.markets_preferences.selected_currency = this.selectedCurrency;
      this.$store.state.user_preferences.all.items.markets_choices = this.markets_preferences;
      saveUserPreferences(this);
      let asset = "currency";
      const menuPromise = getMenu(this, asset);
      this.getSpotDataFn();
      Object.assign(this.activeElements, {
        currency: this.currencyName,
        analysis: this.view[this.selectedShowView].name,
      });
      this.syncMarketsRoute();
      return menuPromise.then(() => this.syncMarketsRoute(true));
    },
    marketsItemSlug() {
      return slugifyProductItem(this.currencyDefs.currency_name);
    },
    marketsFindItem(slug) {
      const target = slugifyProductItem(slug);
      return this.currencySpecs.findIndex(
        (d) => slugifyProductItem(d.currency_name) === target,
      );
    },
    applyMarketsItem(slug) {
      const indexCurr = this.marketsFindItem(slug);
      if (indexCurr < 0 || indexCurr === this.selectedCurrency) {
        return Promise.resolve();
      }
      return this.onUserCurrencySelection({
        item: this.currencySpecs[indexCurr],
      });
    },
    onComparisonSelection({ type, asset }) {
      this.compareType = type || null;
      this.compareAsset = asset || null;
      if (this.selectedShowView === "comparison") {
        this.syncMarketsRoute();
      }
    },
    marketsRouteQuery() {
      const query = {};
      if (this.selectedShowView === "comparison" && this.compareType) {
        query.compareType = this.compareType;
        if (this.compareAsset) query.compareAsset = this.compareAsset;
      }
      return query;
    },
    applyMarketsQuery(route) {
      if (route.query.compareType) {
        this.compareType = route.query.compareType;
        this.compareAsset = route.query.compareAsset || null;
      }
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this["userSelections"], {
        visibleLeft: val,
      });
    },
    resizeCharts() {
      let rBool = this.render;
      for (let i = 0; i < 1; i++) {
        setTimeout(() => {
          Object.assign(this, {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }

      Object.assign(this, {
        render: !this["render"],
      });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this["userSelections"], {
        selectedAnalysisParent: parent,
      });
      Object.assign(this["userSelections"], {
        selectedAnalysis: val,
      });
      setTimeout(() => {
        Object.assign(this["userSelections"], {
          visibleLeft: false,
        });
      }, 500);
    },
    updateSpotMethod() {
      this.showLoadingSpot = true;
      this.showLoading = true;
      this.getSpotDataFn();
    },
    changeVisible() {
      Object.assign(this.userSelections, {
        visibleLeft: !this.userSelections.visibleLeft,
      });
      this.$emit("getOpenElements");
    },
    changeViewBoolean() {
      this.selectedView = 1 - this.selectedView;
      if (this.selectedView === 0) {
        this.view = this.view_user;
      } else if (this.selectedView === 1) {
        this.view = this.view_quanspire;
      }
      this.syncMarketsRoute();
    },
    changeView(view_selection) {
      if (view_selection === "myview") {
        this.view = this.view_user;
        this.selectedView = 0;
      }
      if (view_selection === "quanspire") {
        this.view = this.view_quanspire;
        this.selectedView = 1;
      }
      this.syncMarketsRoute();
    },
    verifySpotData() {
      if (this.chartDataRaw === undefined) {
        return;
      } else if (this.chartDataRaw.length === 0) {
        return;
      }
      const spotData = this.spotData;
      const lastChartData = this.chartDataRaw.at(-1);
      if (spotData) {
        const isEndpointBack = !!spotData["close"];

        const observationDateTime = isEndpointBack
          ? spotData["observation_date"]
          : `${spotData["time"]}`;
        const dateObj = new Date(observationDateTime);
        if (+dateObj < +lastChartData.date) {
          const date = formatDate_DDMMMYHMS(lastChartData.date);
          this["updatedAt"] = "Updated at: " + date;
          this.updatedDate = date;
          this["spot"] = +lastChartData.close;
        }
      }
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    // ================ APIs ================ ================ ================ ================
    onSaveView() {
      let params = {
        method: "POST",
        endpoint: "create_menu_configuration",
        content_type: "application/json",
        query_params: {
          format: "json",
          view_markets_side_menu: this.view,
          fk_iduser: this.user.pk_idusers,
          fk_idcurrency: this.currencyNumber,
          fk_idstate: 1,
        },
      };
      this.modal_processing_message.showModalLoading = !this
        .modal_processing_message.showModalLoading;
      this.modal_processing_message.messageModal = "Processing....";
      apiService
        .getAll(params)
        .then((data) => {
          this.modal_processing_message.showModalLoading = !this
            .modal_processing_message.showModalLoading;
          this.modal_process_finished_message.showModalLoading = !this
            .modal_process_finished_message.showModalLoading;
          this.modal_process_finished_message.optionsModal = true;
          this.modal_process_finished_message.messageModal = data;
        })
        .catch(function(error) {
          console.error("An error has occurred" + error);
          this.modal_processing_message.showModalLoading = !this
            .modal_processing_message.showModalLoading;
          this.modal_process_finished_message.showModalLoading = !this
            .modal_process_finished_message.showModalLoading;
          this.modal_process_finished_message.optionsModal = true;
          this.modal_process_finished_message.messageModal =
            "An error has occurred" + error;
        });
    },
    validateDateSpotData(data, time) {
      const chicagoTZ = "America/Chicago";
      const currentDate = new Date();
      const chicagoCurrentDate = new Date(
        currentDate.toLocaleString("en-US", { timeZone: chicagoTZ }),
      );

      const newDate = new Date(data[time]);
      if (
        +newDate > +chicagoCurrentDate &&
        chicagoCurrentDate.getHours() < 20
      ) {
        return {
          ...data,
          [time]: chicagoCurrentDate,
        };
      }

      return data;
    },
    getSpotDataFn() {
      let _this = this;
      this["showLoadingSpot"] = true;
      this["showLoading"] = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot")
        .then((data) => {
          // const isEndpointBack = this.faildGetHistoricalData;
          const isEndpointBack = !!Array.isArray(data);
          data = isEndpointBack ? data[0] : data;
          const time = isEndpointBack ? "observation_date" : "time";
          data = this.validateDateSpotData(data, time);
          let observationDateTime = `${data[time]}`;
          this["spotData"] = data;

          if (observationDateTime === "undefined") {
            observationDateTime = `${data["observation_date"]}`;
          }
          const dateObj = new Date(observationDateTime);
          const dateFormat = formatDate_DDMMMYHMS(dateObj);
          this["updatedAt"] = "Updated at: " + dateFormat;
          this.updatedDate = dateFormat;

          if (isEndpointBack) {
            this["spot"] = Number(data.close);
          } else {
            this["spot"] = data.close;
          }
          this["showLoadingSpot"] = false;
        })
        .catch(function(error) {
          _this["spot"] = null;
          _this["updatedAt"] = "...";
          _this["updatedDate"] = "...";
          _this["showLoadingSpot"] = false;
          console.error(error);
        });
      getCandleData(this, "technical_analysis_historical")
        .then((data) => {
          Object.assign(this, { chartDataRaw: data });
          this["showLoading"] = false;
        })
        .catch(function(error) {
          _this["showLoading"] = false;
          _this["chartDataRaw"] = [];
          console.error(error);
        });
    },
    receiveMessage(message) {
      let _this = this;
      if (this.currencyDefs.currency_name === message["contract"]) {
        const date = timeParseNoNull2(message["time"]);
        const dateFormat = formatDate_DDMMMYHMS(date);
        this.updatedAt = "Updated at: " + dateFormat;
        this["updatedDate"] = dateFormat;
        this.spot = +message["close"];
        this.spotAnimate = Math.sign(this.spot - this.previousSpot);
        this.isDateBefore(_this, _this.chartDataRaw, date);
        setTimeout(() => {
          _this.spotAnimate = 0;
        }, 1500);
        this.previousSpot = this.spot;
      }
    },
    isDateBefore(_this, data, observationDate) {
      if (data === undefined) {
        return;
      }
      const obserDateHours = new Date(observationDate.getTime());
      obserDateHours.setHours(0, 0, 0, 0);
      const dataLastDate = data?.length
        ? [...data].at(-1)?.date.setHours(0, 0, 0, 0)
        : null;
      const time = _this.spotData.time ? "time" : "observation_date";
      const isClose = "close";
      // Validate if the data is not updated
      if (+dataLastDate < +obserDateHours) {
        if (+new Date(_this.spotData[time]) < +obserDateHours) {
          let newSpotData = {
            [isClose]: _this.spot,
            [time]: observationDate,
          };

          Object.assign(_this.spotData, newSpotData);
        }
        Object.assign(_this, {
          chartDataRaw: _this.processData.includeSpotNew(
            _this["chartDataRaw"],
            _this["spotData"],
          ),
        });
      }
    },
    verifyLastTwoDates(_this, data) {
      // Last date
      const dataLastDate = data?.length
        ? [...data].at(-1)?.date.setHours(0, 0, 0, 0)
        : null;
      // Before last date
      const dataBeforeLastDate = data?.length
        ? [...data].at(-2)?.date.setHours(0, 0, 0, 0)
        : null;
      // validate if data does not repeat
      if (
        dataLastDate &&
        dataBeforeLastDate &&
        +dataLastDate === +dataBeforeLastDate
      ) {
        const newData = [...data];
        newData.splice(data.length - 2, 1);
        Object.assign(_this, {
          chartDataRaw: newData,
        });
      }
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped>
.active .toggle__switch_g::after {
  background: var(--expo);
  border: 1px solid var(--expo);
  box-shadow: 0 0 1px var(--graylightbackground);
  left: calc(50% - 2px) !important;
  width: 50%;
}
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
.toggle__button_rt .toggle__switch_rt {
  min-height: 16px !important;
}
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "LAST RECORD";
  font-size: 0.58rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "QUANSPIRE";
}
.container-spot {
  gap: 5px;
}
</style>
